// extracted by mini-css-extract-plugin
module.exports = {"xss":"375px","xs":"420px","md":"767px","md-small":"650px","lg":"991px","xl":"1199px","xxl":"1679px"};